module.exports = __webpack_public_path__ + "static/media/maintenance-hero-4x5.70ba4597.jpg";